import * as R from 'ramda'

export const arrayAsHookDependencies = R.unless(
  R.isNil,
  R.compose(R.join(', '), R.sort(R.subtract)),
)
